const HeadersRequests = [
  { text: 'ID', value: 'request.display_id', sortable: false, show: true },
  { text: 'Estado', value: 'request.status', sortable: false, show: true },
  { text: 'Rubro', value: 'request.rubro', sortable: false, show: true },
  { text: 'Servicio', value: 'request.service', sortable: false, show: true },
  { text: 'Cliente', value: 'request.client', sortable: false, show: true },
  { text: 'Dirección', value: 'request.address', sortable: false, show: true },
  { text: 'Ciudad', value: 'request.city', sortable: false, show: true }
]

export default HeadersRequests
